import {createContext} from "react";

import type {AutosavingStatus, JsonObject, JsonPath} from "./types.ts";

type CoeditingState = Readonly<{
    documentTitle: string;
    templateName: string;
    configOverride: string;
    data: JsonObject;
    savingStatus: AutosavingStatus;
    isLoading: (opts?: {placeholderKey?: string; path?: JsonPath}) => boolean;
    langfuseUrl?: string;
    lastError?: Error;
    viewOnly?: boolean;
}>;

export const CoeditingStateContext = createContext<CoeditingState>({
    documentTitle: "",
    templateName: "",
    configOverride: "",
    savingStatus: "idle",
    isLoading: () => false,
    data: {},
    viewOnly: false,
});
